<div class="sort-container" (click)="$event.stopPropagation()">
  <div class="d-flex gap-2">
    <div class="sort-label">
      <div class="sort-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M3.33325 15.8333H6.66659V14.1666H3.33325V15.8333ZM3.33325 5.83331V7.49998H16.6666V5.83331H3.33325ZM3.33325 11.6666H11.6666V9.99998H3.33325V11.6666Z"
            fill="#5E5E5E"
          />
        </svg>
      </div>
      <span>SORT BY</span>
    </div>
  </div>

  <div class="sort-actions">
    <div class="sort-dropdown" (click)="toggleSortDropdown($event)">
      <div class="selected-sort">
        {{ selectedSort.label }}
      </div>
      <div class="dropdown-icon" [class.expanded]="isSortDropdownOpen">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M5 7.5L10 12.5L15 7.5"
            stroke="#383838"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="dropdown-menu" *ngIf="isSortDropdownOpen">
        <div
          class="dropdown-item"
          *ngFor="let option of sortOptions"
          (click)="setSortOption(option); $event.stopPropagation()"
        >
          {{ option.label }}
        </div>
      </div>
    </div>

    <!-- <button *ngIf="showActionButton" class="btn action-btn" (click)="onActionButtonClick()">
      {{ actionButtonText }}
    </button> -->
  </div>
</div>
